import InformationStrip from "./InformationStrip";
export default InformationStrip;